import { Action } from 'redux';

import { IUserSettings } from '../../ts/models/IUserSettings';
import { UpdateUserSettings } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';

export interface UpdateUserSettingsAction extends Action {
  domain: string;
  username: string;
  userSettings: IUserSettings;
}

export function updateUserSettingsAction(username: string, domain: string, userSettings: IUserSettings): UpdateUserSettingsAction {
  return {
    type: UpdateUserSettings,
    domain: domain,
    username: username,
    userSettings: userSettings
  };
}

export const isUpdateUserSettingsAction = isActionFactory<UpdateUserSettingsAction>(UpdateUserSettings);
